import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaChevronDown,
  FaChevronUp,
  FaMinusSquare,
  FaPlusSquare,
  FaTimesCircle,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "./SideMenu.css";

const SPORT_DEFINITIONS = [
  {
    id: "politics",
    label: "Politics",
    eventType: 0,
  },
  {
    id: "cricket",
    label: "Cricket",
    eventType: 4,
  },
  {
    id: "football",
    label: "Football",
    eventType: 1,
  },
  {
    id: "tennis",
    label: "Tennis",
    eventType: 2,
  },
  {
    id: "table-tennis",
    label: "Table Tennis",
    eventType: 8,
  },
  {
    id: "badminton",
    label: "Badminton",
    eventType: 10,
  },
  {
    id: "esoccer",
    label: "Esoccer",
    eventType: 15,
  },
  {
    id: "basketball",
    label: "Basketball",
    eventType: 7,
  },
  {
    id: "volleyball",
    label: "Volleyball",
    eventType: 11,
  },
  {
    id: "snooker",
    label: "Snooker",
    eventType: 14,
  },
  {
    id: "ice-hockey",
    label: "Ice Hockey",
    eventType: 12,
  },
];

const SideMenu = ({
  handleToggleMenu,
  closeSideMenu,
  isMobile,
  whatsappNum,
  setEventType,
}) => {
  const navigate = useNavigate();
  const userInfo = Helper();
  const eventStore = useSelector((state) => state.events);
  const [search, setSearch] = useState("");

  const [openSections, setOpenSections] = useState({
    racing: true,
    others: true,
    sports: true,
  });

  const [expandedSports, setExpandedSports] = useState({});

  const racingItems = [
    {
      id: "horse-racing",
      label: "Horse Racing",
      path: "/horse-racing",
    },
    {
      id: "greyhound-racing",
      label: "Greyhound Racing",
      path: "/greyhound-racing",
    },
  ];

  const otherItems = [
    {
      id: "our-casino",
      label: "Our Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-vip-casino",
      label: "Our VIP Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-premium-casino",
      label: "Our Premium Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-virtual",
      label: "Our Virtual",
      disabled: true,
      blink: true,
    },
    {
      id: "live-casino",
      label: "Live Casino",
      casino: "evolution",
    },
    {
      id: "slot-game",
      label: "Slot Game",
      casino: "sa-gaming-casino",
    },
    {
      id: "fantasy-game",
      label: "Fantasy Game",
      casino: "fantasy",
    },
  ];

  const allEvents = useMemo(() => {
    const eventGroups = Array.isArray(eventStore?.events)
      ? eventStore.events
      : [];

    const flattenedEvents = eventGroups
      .flatMap((eventGroup) => eventGroup?.competitions || [])
      .flatMap((competition) => competition?.events || []);

    // Same event multiple competitions me aaye to duplicate remove hoga.
    return Array.from(
      new Map(
        flattenedEvents.map((event) => [
          String(
            event?.event_id ??
            event?.eventId ??
            event?._id
          ),
          event,
        ])
      ).values()
    );
  }, [eventStore?.events]);

  const sportItems = useMemo(() => {
    return SPORT_DEFINITIONS.map((sport) => {
      const children = allEvents
        .filter((event) => {
          const eventType =
            event?.event_type ??
            event?.eventType ??
            event?.event_type_id;

          return String(eventType) === String(sport.eventType);
        })
        .map((event) => {
          const eventId = String(
            event?.event_id ??
            event?.eventId ??
            event?._id ??
            ""
          );

          const eventName =
            event?.event_name ??
            event?.eventName ??
            event?.name ??
            "Event";

          const inPlayValue =
            event?.is_inplay ??
            event?.isInplay ??
            event?.isInPlay;

          const isLive =
            inPlayValue === true ||
            inPlayValue === 1 ||
            inPlayValue === "1" ||
            String(inPlayValue).toLowerCase() === "true";

          return {
            id: eventId,
            label: eventName,
            eventId,
            isLive,
            path: `/matchupdates/${eventId}/${isLive ? "Inplay" : "Going Inplay"
              }`,
          };
        });

      return {
        ...sport,
        children,
      };
    });
  }, [allEvents]);

  const toggleSport = (sportId) => {
    setExpandedSports((previous) => {
      // Same sport dobara click hua to close hoga.
      if (previous[sportId]) {
        return {};
      }

      // Naya sport open hoga aur pehle wala close ho jayega.
      return {
        [sportId]: true,
      };
    });
  };

  const toggleSection = (sectionName) => {
    setOpenSections((current) => ({
      ...current,
      [sectionName]: !current[sectionName],
    }));
  };

  const closeMenu = () => {
    if (typeof closeSideMenu === "function") {
      closeSideMenu();
      return;
    }

    if (typeof handleToggleMenu === "function") {
      handleToggleMenu();
    }
  };

  const openPath = (item) => {
    if (item.eventType !== undefined && setEventType) {
      setEventType(item.eventType);
    }

    closeMenu();

    navigate(item.path, {
      state:
        item.eventType !== undefined
          ? { eventType: item.eventType }
          : undefined,
    });
  };

  const openCasino = (item) => {
    if (item.disabled) return;

    if (!userInfo?._id) {
      closeMenu();
      navigate("/login");
      return;
    }

    closeMenu();

    navigate("/all-games-lobby", {
      state: {
        activeCasino: item.casino,
      },
    });
  };

  const openSportLeague = (sport, event) => {
    if (
      sport.eventType !== undefined &&
      typeof setEventType === "function"
    ) {
      setEventType(sport.eventType);
    }

    closeMenu();

    navigate(event.path, {
      state: {
        eventType: sport.eventType,
        eventId: event.eventId,
      },
    });
  };

  const filterItems = (items) => {
    const value = search.trim().toLowerCase();

    if (!value) return items;

    return items.filter((item) =>
      item.label.toLowerCase().includes(value)
    );
  };

  const filterSports = (items) => {
    const value = search.trim().toLowerCase();

    // Search empty hai to complete sports list return hogi
    if (!value) {
      return items;
    }

    return items
      .map((sport) => {
        // Sport name match ho raha hai ya nahi
        const sportMatches = sport.label
          .toLowerCase()
          .includes(value);

        // Sport ke andar matching leagues
        const matchingChildren = (
          sport.children || []
        ).filter((league) =>
          league.label.toLowerCase().includes(value)
        );

        /*
         * Na sport match hua aur na koi league,
         * to is sport ko result se remove kar denge.
         */
        if (
          !sportMatches &&
          matchingChildren.length === 0
        ) {
          return null;
        }

        /*
         * Agar sport ka naam match hua:
         * uski saari leagues show hongi.
         *
         * Agar sirf child league match hui:
         * sirf matching leagues show hongi.
         */
        return {
          ...sport,
          children: sportMatches
            ? sport.children
            : matchingChildren,
        };
      })
      .filter(Boolean);
  };

  const filteredRacing = useMemo(
    () => filterItems(racingItems),
    [search]
  );

  const filteredOthers = useMemo(
    () => filterItems(otherItems),
    [search]
  );

  const filteredSports = useMemo(
    () => filterSports(sportItems),
    [search]
  );


  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  // const handleAviator = () => {
  //   if (userInfo) {
  //     CreateAndLaunchWCOCasino(`SPB`, `aviator`);
  //   } else {
  //     setShowMenu(false);
  //     setShowLoginModel(true);
  //   }
  // };

  function OpenEzugiLobby(casinoType) {
    handleToggleMenu();
    navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
  }

  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  const MenuSection = ({
    sectionKey,
    title,
    children,
  }) => {
    const isOpen = openSections[sectionKey];

    return (
      <section className="reference-side-section">
        <button
          type="button"
          className="reference-side-section-heading"
          onClick={() => toggleSection(sectionKey)}
          aria-expanded={isOpen}
        >
          <span>{title}</span>

          {isOpen ? (
            <FaChevronUp aria-hidden="true" />
          ) : (
            <FaChevronDown aria-hidden="true" />
          )}
        </button>

        {isOpen && (
          <div className="reference-side-section-body">
            {children}
          </div>
        )}
      </section>
    );
  };


  return (

    <aside
      className={[
        "reference-side-menu",
        isMobile
          ? "reference-side-menu-mobile"
          : "reference-side-menu-desktop",
      ].join(" ")}
      aria-label="Main navigation"
    >
      {/* Search and close */}
      {isMobile && (
        <div className="reference-side-search-row">
          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            className="reference-side-search"
            placeholder="Search here"
            aria-label="Search menu"
          />

          <button
            type="button"
            className="reference-side-close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <i
              className="far fa-times-circle"
              aria-hidden="true"
            />
          </button>
        </div>
      )}

      <div className="reference-side-scroll">
        {/* Racing Sports */}
        <MenuSection
          sectionKey="racing"
          title="Racing Sports"
        >
          {filteredRacing.map((item) => (
            <button
              key={item.id}
              type="button"
              className="reference-side-row"
              onClick={() => openPath(item)}
            >
              {item.label}
            </button>
          ))}
        </MenuSection>

        {/* Others */}
        <MenuSection
          sectionKey="others"
          title="Others"
        >
          {filteredOthers.map((item) => (
            <button
              key={item.id}
              type="button"
              className={[
                "reference-side-row",
                item.disabled ? "reference-side-row-disabled" : "",
                item.blink ? "reference-side-row-blink" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              disabled={item.disabled}
            >
              <span>{item.label}</span>
            </button>
          ))}
        </MenuSection>

        {/* All Sports */}
        <MenuSection
          sectionKey="sports"
          title="All Sports"
        >
          {filteredSports.map((sport) => {
            const isExpanded = Boolean(
              expandedSports[sport.id]
            );

            return (
              <div
                key={sport.id}
                className="reference-sport-group"
              >
                <button
                  type="button"
                  className="reference-side-row reference-sport-row"
                  onClick={() => toggleSport(sport.id)}
                  aria-expanded={isExpanded}
                >
                  {isExpanded ? (
                    <i
                      className="far fa-minus-square me-1 reference-sport-plus"
                      aria-hidden="true"
                    />
                  ) : (
                    <i
                      className="far fa-plus-square me-1 reference-sport-plus"
                      aria-hidden="true"
                    />
                  )}

                  <span>{sport.label}</span>
                </button>

                {isExpanded && (
                  <div className="reference-sport-children">
                    {sport.children?.length > 0 ? (
                      sport.children.map((event) => (
                        <button
                          key={event.id}
                          type="button"
                          className="reference-side-row reference-league-row"
                          onClick={() => openSportLeague(sport, event)}
                          title={event.label}
                        >
                          <i
                            className="far fa-plus-square me-1 reference-league-plus"
                            aria-hidden="true"
                          />

                          <span>{event.label}</span>
                        </button>
                      ))
                    ) : (
                      <div className="reference-sport-no-events">
                        No events available
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </MenuSection>

        {filteredRacing.length === 0 &&
          filteredOthers.length === 0 &&
          filteredSports.length === 0 && (
            <div className="reference-side-empty">
              No menu found
            </div>
          )}
      </div>
    </aside>
  );
}

export default SideMenu